class Utils{
    static GetUserDetails(){
       return JSON.parse(localStorage.getItem("user"));
    }
}
export default Utils;
